import { useTheme } from "@emotion/react";
import EastIcon from "@mui/icons-material/East";
import WestIcon from "@mui/icons-material/West";
import { Button, Tooltip } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useStyles } from "../../../theme/style";
import { LightTooltip } from "../../../kit/LightToolTip";
import AssignIcon from "../../../../assets/images/imageComponent/AssignIcon";
import { useDispatch } from "react-redux";
import { rapidSaveAsDraft } from "../../../services/api";
import { updateAlertInfo } from "../../../redux/slice/userSlice";
import { useSelector } from "react-redux";
import APP_CONSTANTS from "../../../utils/config";

const EditableRapidFooter = ({
  handleBack,
  handleNext,
  handleSubmit,
  buttonState,
  register_id,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const infraDataJson = useSelector((state) => state.data.rapidData?.infraJson);
  const detailsJson = useSelector((state) => state.data.rapidData?.detailsJson);
  const appStatus =
    useSelector((state) => state.data.rapidData?.current_status) || "";

  // const handleSaveAsDraft = async () => {
  //   const payload = {
  //     infra_details: infraDataJson,
  //     details: detailsJson,
  //     status: appStatus || "",
  //     request_id: register_id || "",
  //   };
  //   try {
  //     const resp = await rapidSaveAsDraft({
  //       payload: payload,
  //     });
  //     const statusCode = resp?.data?.status?.statusCode;
  //     const message = resp?.data?.status?.statusMessage;
  //     if (statusCode === 200) {
  //       navigate("/rapid");
  //       dispatch(
  //         updateAlertInfo({
  //           message: "Application is saved as draft",
  //           open: true,
  //           severity: "success",
  //         })
  //       );
  //     } else {
  //       dispatch(
  //         updateAlertInfo({
  //           message: message,
  //           open: true,
  //           severity: "error",
  //         })
  //       );
  //     }
  //   } catch (err) {
  //     console.error("Error", err);
  //   }
  // };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        // position: "absolute",
        // bottom: -10,
        width: "100%",
        marginTop: "16px",
      }}
    >
      <div>
        <div>
          <Button
            disableRipple
            className={classes.outlinedButton}
            onClick={handleBack}
            style={{
              fontWeight: theme.fontWeight[500],
              marginLeft: theme.size[4],
            }}
            disabled={!buttonState.back}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <WestIcon
                sx={{
                  fontSize: theme.size[18],
                  marginRight: theme.size[4],
                }}
              />
              <span>Back</span>
            </div>
          </Button>

          {/* {(register_id === "" ||
            appStatus === APP_CONSTANTS.RAPID_STATUS.PROCESS_INITIATED) && (
            <Button
              disableRipple
              className={classes.outlinedButton}
              onClick={handleSaveAsDraft}
              style={{
                fontWeight: theme.fontWeight[500],
                background: theme.palette.saveAsDraftButton.background,
                color: theme.palette.saveAsDraftButton.text,
                border: `1px solid ${theme.palette.saveAsDraftButton.background}`,
                marginLeft: theme.size[8],
              }}
              disabled={!buttonState.saveAsDraft}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span>Save as Draft</span>
              </div>
            </Button>
          )} */}
        </div>
        <div
          style={{
            fontSize: theme.size[12],
            fontWeight: theme.fontWeight[500],
            color: theme.palette.rapidInfra.text,
            paddingTop: theme.size[4],
          }}
        >
          Back to Projects
        </div>
      </div>

      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            // gap: theme.size[16],
          }}
        >
          {/* {(register_id === "" ||
            appStatus === APP_CONSTANTS.RAPID_STATUS.PROCESS_INITIATED) && ( */}
            <Button
              disableRipple
              className={classes.outlinedButton}
              onClick={handleSubmit}
              style={{
                fontWeight: theme.fontWeight[500],
                marginRight: theme.size[8],
              }}
              disabled={!buttonState.submit}
            >
              <LightTooltip
                title="Delegate the task to Technical User"
                placement="top"
                arrow
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <AssignIcon
                    color={
                      buttonState.submit
                        ? theme.palette.primary.darkViolet
                        : "#000"
                    }
                    width={theme.size[16]}
                    height={theme.size[16]}
                  />

                  <span style={{ marginLeft: theme.size[4] }}>Assign</span>
                </div>
              </LightTooltip>
            </Button>
          {/* )} */}

          <Button
            disableRipple
            className={classes.filledButton}
            onClick={handleNext}
            style={{
              fontWeight: theme.fontWeight[500],
            }}
            disabled={!buttonState.next}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span>Next</span>
              <EastIcon
                sx={{
                  fontSize: theme.size[18],
                  marginLeft: theme.size[4],
                }}
              />
            </div>
          </Button>
        </div>
        <div
          style={{
            fontSize: theme.size[12],
            fontWeight: theme.fontWeight[500],
            color: theme.palette.rapidInfra.text,
            paddingTop: theme.size[4],
            textAlign: "right",
          }}
        >
          Project Types and Components
        </div>
      </div>
      {/* <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: theme.size[16],
        }}
      >
        {(register_id === "" ||
          appStatus === APP_CONSTANTS.RAPID_STATUS.PROCESS_INITIATED) && (
          <Button
            disableRipple
            className={classes.outlinedButton}
            onClick={handleSubmit}
            style={{
              fontWeight: theme.fontWeight[500],
              marginRight: theme.size[8],
            }}
            disabled={!buttonState.submit}
          >
            <LightTooltip
              title="Delegate the task to Technical User"
              placement="top"
              arrow
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <AssignIcon
                  color={
                    buttonState.submit ? theme.palette.secondary.main : "#000"
                  }
                  width={theme.size[16]}
                  height={theme.size[16]}
                />

                <span style={{ marginLeft: theme.size[4] }}>Assign</span>
              </div>
            </LightTooltip>
          </Button>
        )}

        <Button
          disableRipple
          className={classes.filledButton}
          onClick={handleNext}
          style={{
            fontWeight: theme.fontWeight[500],
          }}
          disabled={!buttonState.next}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span>Next</span>
            <EastIcon
              sx={{
                fontSize: theme.size[18],
                marginLeft: theme.size[4],
              }}
            />
          </div>
        </Button>
      </div> */}
    </div>
  );
};

export default EditableRapidFooter;
